import React from 'react';

export default function SkeletonLoader({ type = 'sidebar', count = 5, style = {}, className = '' }) {
  const containerStyle = {
    width: '100%',
    boxSizing: 'border-box',
    ...style
  };

  if (type === 'sidebar') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '16px', ...containerStyle }} className={className}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div className="skeleton-shimmer" style={{ width: '28px', height: '28px', borderRadius: '50%', flexShrink: 0 }} />
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <div className="skeleton-shimmer" style={{ height: '12px', width: '70%', borderRadius: '4px' }} />
              <div className="skeleton-shimmer" style={{ height: '9px', width: '40%', borderRadius: '3px' }} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (type === 'chat-bubble') {
    return (
      <div style={{ padding: '12px 16px', display: 'flex', flexDirection: 'column', gap: '8px', width: '100%', maxWidth: '80%', ...containerStyle }} className={className}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
          <div className="skeleton-shimmer" style={{ width: '24px', height: '24px', borderRadius: '50%', flexShrink: 0 }} />
          <div className="skeleton-shimmer" style={{ height: '10px', width: '60px', borderRadius: '4px' }} />
        </div>
        <div className="skeleton-shimmer" style={{ height: '14px', width: '90%', borderRadius: '4px' }} />
        <div className="skeleton-shimmer" style={{ height: '14px', width: '75%', borderRadius: '4px' }} />
        <div className="skeleton-shimmer" style={{ height: '14px', width: '50%', borderRadius: '4px' }} />
      </div>
    );
  }

  if (type === 'grid') {
    return (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px', padding: '24px', ...containerStyle }} className={className}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} style={{ border: '1px solid var(--border)', borderRadius: '12px', padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{ display: 'flex', gap: '12px' }}>
              <div className="skeleton-shimmer" style={{ width: '48px', height: '48px', borderRadius: '10px', flexShrink: 0 }} />
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px', justifyContent: 'center' }}>
                <div className="skeleton-shimmer" style={{ height: '16px', width: '80%', borderRadius: '4px' }} />
                <div className="skeleton-shimmer" style={{ height: '12px', width: '50%', borderRadius: '3px' }} />
              </div>
            </div>
            <div className="skeleton-shimmer" style={{ height: '36px', width: '100%', borderRadius: '6px' }} />
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px' }}>
              <div className="skeleton-shimmer" style={{ height: '10px', width: '60px', borderRadius: '2px' }} />
              <div className="skeleton-shimmer" style={{ height: '10px', width: '40px', borderRadius: '2px' }} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (type === 'detail') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', padding: '32px', maxWidth: '1000px', margin: '0 auto', ...containerStyle }} className={className}>
        <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
          <div className="skeleton-shimmer" style={{ width: '96px', height: '96px', borderRadius: '20px', flexShrink: 0 }} />
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div className="skeleton-shimmer" style={{ height: '32px', width: '60%', borderRadius: '6px' }} />
            <div className="skeleton-shimmer" style={{ height: '16px', width: '30%', borderRadius: '4px' }} />
          </div>
        </div>
        <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
          <div style={{ flex: 2, display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div className="skeleton-shimmer" style={{ height: '240px', width: '100%', borderRadius: '12px' }} />
            <div className="skeleton-shimmer" style={{ height: '16px', width: '100%', borderRadius: '4px' }} />
            <div className="skeleton-shimmer" style={{ height: '16px', width: '95%', borderRadius: '4px' }} />
            <div className="skeleton-shimmer" style={{ height: '16px', width: '80%', borderRadius: '4px' }} />
          </div>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '12px', minWidth: '250px' }}>
            <div className="skeleton-shimmer" style={{ height: '48px', width: '100%', borderRadius: '8px' }} />
            <div className="skeleton-shimmer" style={{ height: '48px', width: '100%', borderRadius: '8px' }} />
            <div className="skeleton-shimmer" style={{ height: '100px', width: '100%', borderRadius: '8px' }} />
          </div>
        </div>
      </div>
    );
  }

  if (type === 'document') {
    return (
      <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px', ...containerStyle }} className={className}>
        <div className="skeleton-shimmer" style={{ height: '32px', width: '50%', borderRadius: '6px', marginBottom: '8px' }} />
        <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
          <div className="skeleton-shimmer" style={{ height: '18px', width: '80px', borderRadius: '4px' }} />
          <div className="skeleton-shimmer" style={{ height: '18px', width: '60px', borderRadius: '4px' }} />
        </div>
        <div className="skeleton-shimmer" style={{ height: '14px', width: '100%', borderRadius: '4px' }} />
        <div className="skeleton-shimmer" style={{ height: '14px', width: '98%', borderRadius: '4px' }} />
        <div className="skeleton-shimmer" style={{ height: '14px', width: '92%', borderRadius: '4px' }} />
        <div className="skeleton-shimmer" style={{ height: '14px', width: '95%', borderRadius: '4px' }} />
        <div className="skeleton-shimmer" style={{ height: '14px', width: '60%', borderRadius: '4px', marginBottom: '24px' }} />
        
        <div className="skeleton-shimmer" style={{ height: '24px', width: '30%', borderRadius: '6px', marginBottom: '8px' }} />
        <div className="skeleton-shimmer" style={{ height: '14px', width: '100%', borderRadius: '4px' }} />
        <div className="skeleton-shimmer" style={{ height: '14px', width: '85%', borderRadius: '4px' }} />
      </div>
    );
  }

  if (type === 'landscape-cards') {
    return (
      <div className={`skeleton-landscape-cards-grid ${className || ''}`} style={containerStyle}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} style={{ display: 'flex', flexDirection: 'column', width: '100%', borderRadius: '16px', border: '1px solid var(--iv-band-line)', background: 'var(--iv-band)', padding: '12px', boxSizing: 'border-box' }}>
            <div className="skeleton-shimmer" style={{ width: '100%', height: '140px', borderRadius: '12px' }} />
            <div className="skeleton-shimmer" style={{ height: '16px', width: '75%', borderRadius: '4px', marginTop: '12px' }} />
            <div className="skeleton-shimmer" style={{ height: '12px', width: '90%', borderRadius: '3px', marginTop: '8px' }} />
            <div className="skeleton-shimmer" style={{ height: '12px', width: '60%', borderRadius: '3px', marginTop: '4px' }} />
          </div>
        ))}
      </div>
    );
  }

  if (type === 'squircle-cards') {
    return (
      <div style={{ display: 'flex', flexDirection: 'row', gap: '24px', padding: '12px 24px 20px', overflow: 'hidden', ...containerStyle }} className={className}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} style={{ display: 'flex', flexDirection: 'column', width: '180px', flexShrink: 0, alignItems: 'center' }}>
            <div className="skeleton-shimmer" style={{ width: '160px', height: '160px', borderRadius: '12px' }} />
            <div className="skeleton-shimmer" style={{ height: '14px', width: '80%', borderRadius: '4px', marginTop: '12px' }} />
            <div className="skeleton-shimmer" style={{ height: '11px', width: '40%', borderRadius: '3px', marginTop: '8px' }} />
          </div>
        ))}
      </div>
    );
  }

  if (type === 'table' || type === 'list') {
    return (
      <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px', ...containerStyle }} className={className}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="skeleton-shimmer" style={{ height: '40px', width: '100%', borderRadius: '8px' }} />
        ))}
      </div>
    );
  }

  return null;
}
